import { Text } from '@thanx/uikit/text'
import { buildTranslate } from 'locales'
import React from 'react'
import { Container } from 'react-bootstrap-five'

const t = buildTranslate('promo_codes.landing')

const EmptyState: React.FC = () => {
  return (
    <Container>
      <div className="text-center py-xxl">
        <Text.Header4 className="mb-s">{t('empty_state.title')}</Text.Header4>
        <Text.BodyText4 className="grey-70">
          {t('empty_state.description')}
        </Text.BodyText4>
      </div>
    </Container>
  )
}

export default EmptyState
